import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
/**
 * Direct selector to the domain's state
 */ const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
export const isPatientSetupProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.PATIENT_SETUP));
export const hasPatientSetupErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.PATIENT_SETUP));
